import { render, staticRenderFns } from "./IncompatipleIcon.vue?vue&type=template&id=0b57d3aa&scoped=true"
import script from "./IncompatipleIcon.vue?vue&type=script&lang=js"
export * from "./IncompatipleIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b57d3aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b57d3aa')) {
      api.createRecord('0b57d3aa', component.options)
    } else {
      api.reload('0b57d3aa', component.options)
    }
    module.hot.accept("./IncompatipleIcon.vue?vue&type=template&id=0b57d3aa&scoped=true", function () {
      api.rerender('0b57d3aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/IncompatipleIcon.vue"
export default component.exports